export const messages = {
  "Home": "Accueil",
  "Loading metadata": "Chargement",
  "Application bootstrap failed": "Échec du démarrage de l’application",
  "Communication failed with the server, please check your internet connection and refresh the page": "La communication avec le serveur a échoué. Vérifiez votre connexion Internet et actualisez la page.",
  "en-US": "Anglais",
  "fr-FR": "Français",
  "ht-HT": "Haïtien",

  "stats.title": "Statistiques de l’inscription électorale",
  "stats.subtitle": "Statistiques publiques actuelles sur les électeurs inscrits et les demandes d’inscription.",
  "stats.applicantHighlights": "Indicateurs clés de l’inscription",
  "stats.registeredVoters": "Électeurs inscrits",
  "stats.applicants": "Demandeurs",
  "stats.activeOperators": "Opérateurs actifs",
  "stats.activeCenters": "Centres d’inscription actifs",
  "stats.configuredCenters": "Centres d’inscription",
  "stats.capacity": "Capacité",
  "stats.capacityUse": "Utilisation de la capacité",
  "stats.capacityUseByDepartment": "Utilisation de la capacité par département",
  "stats.capacityUseByDepartmentSubtitle": "Demandeurs en proportion de la capacité d’inscription configurée.",
  "stats.applicantActivity": "Activité des demandeurs",
  "stats.applicantActivitySubtitle": "Demandes soumises au fil du temps.",
  "stats.demographics": "Démographie des électeurs inscrits",
  "stats.demographicsSubtitle": "Répartition des électeurs inscrits par sexe et par âge.",
  "stats.sexDistribution": "Répartition par sexe",
  "stats.ageDistribution": "Répartition par âge",
  "stats.byDepartment": "Électeurs inscrits par département",
  "stats.byDepartmentSubtitle": "Répartition des électeurs inscrits par département.",
  "stats.noData": "Aucune statistique n’est disponible.",
  "stats.loading": "Chargement",
  "stats.male": "Hommes",
  "stats.female": "Femmes",
  "stats.other": "Autre",
  "stats.pendingProcessing": "Demandes en cours de traitement",
  "stats.unknown": "Inconnu",
  "stats.under18": "Moins de 18 ans",
  "stats.18to28": "18 à 28",
  "stats.29to38": "29 à 38",
  "stats.39to48": "39 à 48",
  "stats.49to58": "49 à 58",
  "stats.59to68": "59 à 68",
  "stats.69plus": "69+",
  "reporting.registrationsByDepartment": "Électeurs inscrits par département",
  "reporting.standardActivityDepartments": "Répartition des électeurs inscrits par département.",
  "reporting.geoRegistrations": "Répartition géographique des inscriptions",
  "reporting.geoDrilldownSubtitle": "Répartition et navigation dans la géographie électorale.",
  "reporting.capacityUtilization": "Utilisation de la capacité",
  "reporting.capacityUtilizationByDepartment": "Utilisation de la capacité par département",
  "reporting.capacityUtilizationByDepartmentSubtitle": "Électeurs inscrits en proportion de la capacité configurée.",
  "reporting.registeredVoters": "Électeurs inscrits",
  "reporting.utilization": "Utilisation",
  "reporting.noData": "Aucune donnée disponible",
  "reporting.high": "Élevé",
  "reporting.low": "Faible",
  "geo.capacity": "Capacité",
  "common.unnamed": "Sans nom",
  "common.level": "Niveau",
  "common.metric": "Indicateur",
  "common.area": "Zone"
};
